NS("Security");

Security.Security = Class({
    context: null,

    initialize: function(context) {
        this.context = context;
    },

    init: function(context, callback) {
        var self = this;

        if (context) {
            this.context.update(context);
        } else {
            Xhr.call('security/context')
               .then(response => {
                   if (response.success && response.data) {
                       this.context.update(response.data);
                   }

                   Util.call(callback);
               });
        }

        return this;
    },
    /**
     * @param {string} key
     * @param {number|Array.<Number>} [mode=Security.AccessMode.Execute]
     * @returns {boolean}
     */
    check: function(key, mode) {
        if (!this.context || !this.context.role) {
            return false;
        }

        if (this.context.role.name === 'root') {
            return true;
        }

        if (mode === undefined) {
            mode = Security.AccessMode.Execute;
        }

        var granted = Util.coalesce(this.context.role.access[key], []);

        if (!granted) {
            return false;
        }

        if (!Util.isArray(mode)) {
            mode = [mode];
        }

        //return !!~granted.indexOf(mode);
        return !Util.Array.diff(mode, granted).length;
    },

    isRoot: function() {
        return this.context && this.context.role && this.context.role.name === 'root'
    },

    signIn: function(login, password, callback) {
        var self = this;

        return Xhr.call('security/signIn', {
            login: login,
            password: password
        }, function(result) {
            var ret = false;

            if (result.success && result.data) {
                self.context.update(result.data);
                ret = true;
            }

            Util.call(callback, self, [ret]);
        }, 'POST');
    },

    signOut: function(callback) {
        var self = this;

        return Xhr.call('Security/Web/signOut', function (result) {
            self.context.update(result.data);

            Util.call(callback, self);
        });
    }
});
